import script from "./DatasourceHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasourceHeader.vue?vue&type=script&setup=true&lang=js"

import "./DatasourceHeader.vue?vue&type=style&index=0&id=e6a16070&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6a16070"]])

export default __exports__